// Journal Mutations

export const updateJournalList = (state, payload) => {
  state.journalList = payload
}
